import React from 'react';

import dayjs from 'dayjs';
import styled from 'styled-components';

import { SNAPSHOT_SELECTOR_SELECTION } from 'common/Snapshot/editor/constants';
import { isManagedBySuperuser } from 'helpers/permissions';
import { useAppSelector } from 'store/hook';

import { useShopDataModalContext } from './ShopDataModalContext';

const Container = styled.div`
  padding: 16px 30px;
`;

const Title = styled.div`
  font-size: 20px;
  font-family: var(--font-bold);
`;

const SubTitle = styled.div`
  font-size: 14px;
  font-family: var(--font-regular);
  color: var(--text-secondary);
`;

const CommunityName = styled.span`
  color: var(--dark-blue);
`;

const ShopDataModalHeader = () => {
  const { community, date, mode } = useShopDataModalContext();
  const { currentUser } = useAppSelector((state) => state.auth);

  let title: string;
  const formattedDate = isManagedBySuperuser(currentUser)
    ? dayjs(date).format('MMMM DD YYYY')
    : dayjs(date).format('MMMM YYYY');

  switch (mode) {
    case SNAPSHOT_SELECTOR_SELECTION.MODIFY_HISTORICAL_DATA:
      title = `Edit Historical Data for ${formattedDate}`;
      break;
    case SNAPSHOT_SELECTOR_SELECTION.ENTER_HISTORICAL_DATA:
      title = `Add New Historical Data for ${formattedDate}`;
      break;
    case SNAPSHOT_SELECTOR_SELECTION.MODIFY_CURRENT_DATA:
      title = `Edit Data for ${formattedDate}`;
      break;
    case SNAPSHOT_SELECTOR_SELECTION.ENTER_SHOP_DATA:
      title = `Enter Draft Data`;
      break;
    default:
      title = `Add New Data for ${formattedDate}`;
      break;
  }

  return (
    <Container>
      <Title data-test-id="sd-modal-title">{title}</Title>
      <SubTitle>
        for{' '}
        <CommunityName data-test-id="sd-modal-community-name">
          {community?.comunity_name || 'Unknown Community'}
        </CommunityName>
      </SubTitle>
    </Container>
  );
};

export default ShopDataModalHeader;
